module.exports = __webpack_public_path__ + "media/images/about/structure1-4b2d3d70838ea2bb8e0bce74d97a415f.png";